import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { token, tokenUtils } from '../utils';

function useRefreshToken() {
  const history = useHistory();
  useEffect(() => {
    const data = {};
    token
      .refresh(data)
      .then((result) => {
        if (result.status === 200) {
          tokenUtils.setToken(result.data.jwt);
        } else {
          history.push('/login');
        }
      })
      .catch((error) => {
        try {
          if (error.response.status === 403) {
            history.push('/login');
          }
        } catch (e) {}
      });
  }, [history]);
}

export default useRefreshToken;
